import axios from "../utils/axios";
export const ProjectService = {
  addNewProject: async (formData) => {
    try {
      const response = await axios.post(`/api/project`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      const errorResponse = error?.response?.data;
      throw errorResponse?.errors;
    }
  },

  getProjectList:async(page,limit,searchTerm='',clientType='',status='',priority='',employeeId='',clientVendorId='')=>{
    try {
        const response=await axios.get(`/api/project?page=${page}&limit=${limit}&searchTerm=${searchTerm}&clientType=${clientType}&priority=${priority}&status=${status}&employeeId=${employeeId}&clientVendorId=${clientVendorId}`);
        if(response?.data?.success){
            return response.data.data;
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Error occurred while fetching project list");
    }
  },

  getClientOrVendorByRole:async({clientType})=>{
    
    try {
        const response=await axios.get(`/api/client/getClientsByRole?clientType=${clientType}`);
        if(response?.data?.success){
            return response.data.data;
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Error occurred while fetching data");
    }
  },

  getProjectById:async(id)=>{
    try {
        const response=await axios.get(`/api/project/${id}`);
        if(response?.data?.success){
            return response.data.data;
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Error occurred while fetching project");
    }
  },

  setProjectPriority:async(id,priority)=>{
    try {
        const response=await axios.patch(`/api/project/priority/${id}`,{priority});
        if(response?.data?.success){
            return true;
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Error occurred while setting project priority");
    }
  },

  assignCoordinator:async(projectId,participants)=>{
    try {
      const response=await axios.post(`/api/project/participants/${projectId}`,{participants});
      if(response?.data?.success){
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while assigning coordinator");
    }
  },

  getProjectDocuments:async(projectId,mainFolderId,subFolderId,uploadedBy,page,limit,searchTerm='',documentType,beforeDate)=>{
    const params = {
      mainFolderId: mainFolderId,
      subFolderId: subFolderId,
      documentType: documentType,
      page: page,
      limit: limit,
      uploadBy:uploadedBy,
      searchTerm:searchTerm,
    };
    if (beforeDate) {
      params.beforeDate = beforeDate;
    }
    try {
      const response=await axios.get(`/api/project/documentsByFolders/${projectId}`,
      { params }
      );
      if(response?.data?.success){
        return response.data.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while fetching project documents");
    }
  },

  getProjectDocumentsForClient:async(projectId,uploadedBy,page,limit,searchTerm='',documentType)=>{
    try {
//  `${BASE_URL}/documentsByFolders/${projectId}/${folderId}?uploadBy=MRR`,

      const response=await axios.get(`/api/project/documents/${projectId}?uploadBy=${uploadedBy}&page=${page}&limit=${limit}&searchTerm=${searchTerm}&documentType=${documentType}`);
      if(response?.data?.success){
        return response.data.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while fetching project documents");
    }
  },

  publishedProjectDocument:async(documentId)=>{
    try {
      const response = await axios.patch(`/api/project/published-action/${documentId}`);
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to published project final document");
    }
  },

  viewDocumentById:async(docId)=>{
    try {
      const response=await axios.get(`/api/project/document/${docId}`);
      if(response?.data?.success){

        return response.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while viewing document");
    }
  },

  deleteDocumentById:async(docId)=>{
    try {
      const response=await axios.delete(`/api/project/document/${docId}`);
      if(response?.data?.success){
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while deleting document");
    }
  },

  getStatistics:async()=>{
    try {
      const response=await axios.get('/api/counts/getDashboardCounts');
      if(response?.data?.success){
        return response.data.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while fetching statistics");
    }
  },

  getStatisticsForCoordinator: async () => {
    try {
      const response = await axios.get('/api/counts/getProjectsCountsForCoordinator');
      if (response?.data?.success) {
        return response.data.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while fetching statistics");
    }
  },
  
  changeProjectStatus: async (projectId, status) => {
    try {
        const response = await axios.patch(`/api/project/status/${projectId}`, { status });
        if (response?.data?.success) {
          return response.data
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Failed to change project status");
    }
  },

  uploadDocument: async (projectId, mainFolderId, subFolderId, documentName, document, documentType) => {
    try {
        const formData = new FormData();
        formData.append("mainFolderId", mainFolderId);
        formData.append("subFolderId", subFolderId);
        formData.append("documentName", documentName);
        formData.append("document", document);
        formData.append("documentType", documentType);
        const response = await axios.post(`/api/project/document/${projectId}`,formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            }
        );
        if (response?.data?.success) {
          return response.data.data
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Failed to upload document");
    }
  },

  updateDocument: async (documentId, documentName, document,documentType) => {
    try {
        const formData = new FormData();
        formData.append("documentName", documentName);
        formData.append("document", document);
        formData.append("documentType", documentType);
        const response = await axios.put(`/api/project/document/${documentId}`,formData,{
              headers: {
                    'Content-Type': 'multipart/form-data',
              },
            }
        );
        if (response?.data?.success) {
          return response.data.data;
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Failed to update document");
    }
  },
    
  deleteDocument: async (documentId) => {
      try {
          const response = await axios.delete(`/api/project/document/${documentId}`);
          if (response?.data?.success) {
            return true
          }
      } catch (error) {
          throw new Error(error?.response?.data?.message || "Failed to delete document.");
      }
  },

  getClientProjects: async () => {
      try {
          const response = await axios.get('/api/project/client/projects');
          if (response?.data?.success) {
            return response.data.data;
          }
      } catch (error) {
          throw new Error(
              error?.response?.data?.message || "Failed to fetch client projects."
          );
      }
  },
  
  updateInfo: async (projectId, formData) => {
    try {
        const response = await axios.patch(`/api/project/info/${projectId}`,formData);
        if (response?.data?.success) {
          return true
        }
    } catch (error) {
       const errorResponse = error.response.data;
        throw errorResponse.errors;
    }
  },

  blockProject:async(projectId)=>{
    try {
      const response = await axios.post(`/api/project/block-action/${projectId}`);
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to block project");
    }
  },

  getAssignMembersInProject:async(projectId)=>{
    try {
      const response =await axios.get(`/api/project/participants/${projectId}`);
      if (response?.data?.success) {
        return response.data.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to fetch assign members");
    }
  },

  removeAssignMembersInProject:async(id)=>{
    try {
      const response=await axios.delete(`/api/project/${id}`);
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to remove assign members");
    }
  },

  uploadProjectFinalDocument: async (projectId, documentName, document) => {
    try {
        const formData = new FormData();
        formData.append("documentName", documentName);
        formData.append("document", document);
        const response = await axios.post(`/api/projectFinalDoc/upload-final-document/${projectId}`,formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                withCredentials: true,
            }
        );
        if (response?.data?.success) {
          return response.data.data
        }
    } catch (error) {
        throw new Error(error?.response?.data?.message || "Failed to upload project final document");
    }
  },

  getProjectFinalDocuments:async(projectId,page,limit,searchTerm='')=>{
    try {
      const response=await axios.get(`/api/projectFinalDoc/getProjectfinalDocuments/${projectId}/?page=${page}&limit=${limit}&searchTerm=${searchTerm}`);
      if(response?.data?.success){
        return response.data.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while fetching project final documents");
    }
  },

  viewFinalDocumentById:async(docId)=>{
    try {
      const response=await axios.get(`/api/projectFinalDoc/getDocumentById/${docId}`);
      if(response?.data?.success){

        return response.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Error occurred while viewing final project document");
    }
  },

  publishedProjectFinalDocument:async(documentId)=>{
    try {
      const response = await axios.post(`/api/projectFinalDoc/published-action/${documentId}`);
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to published project final document");
    }
  },

  createNewProjectFolder: async (formData) => {
    try {
      const response = await axios.post(`/api/projectFolder/createFolder`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.success) {
        return true;
      }
    } catch (error) {
      const errorResponse = error?.response?.data;
      throw errorResponse?.errors;
    }
  },

  editNewProjectFolder: async (formData,mainFolderId) => {
    try {
      const response = await axios.patch(`/api/projectFolder/editMainFolderName/${mainFolderId}`,
        formData, 
        {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.success) {
        return response.data;
      }
    } catch (error) {
      const errorResponse = error?.response?.data;
      throw errorResponse?.errors;
    }
  },

  editSubProjectFolder: async (formData,subFolderId) => {
    try {
      const response = await axios.patch(`/api/projectFolder/editSubFolderName/${subFolderId}`,
        formData, 
        {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response?.data?.success) {
        return response.data;
      }
    } catch (error) {
      const errorResponse = error?.response?.data;
      throw errorResponse?.errors;
    }
  },

  getProjectFolders: async (id) => {
      try {
          const response = await axios.get(`/api/projectFolder/getProjectFolders/${id}`);
          if (response?.data?.success) {
            return response.data.data;
          }
      } catch (error) {
          throw new Error(
              error?.response?.data?.message || "Failed to fetch client projects."
          );
      }
  },

  getProjectSubFolders: async (projectId,mainFolderId) => {
      try {
          const response = await axios.get(`/api/projectFolder/getProjectSubFolders/${projectId}/${mainFolderId}`);
          if (response?.data?.success) {
            return response.data.data;
          }
      } catch (error) {
          throw new Error(
              error?.response?.data?.message || "Failed to fetch client projects."
          );
      }
  },

  getProjectAndMainFolderByMainFolderId: async (mainFolderId) => {
      try {
          const response = await axios.get(`/api/projectFolder/getmainfolderdetails/${mainFolderId}`);
          if (response?.data?.success) {
            return response.data.data;
          }
      } catch (error) {
          throw new Error(
              error?.response?.data?.message || "Failed to fetch client projects."
          );
      }
  },

  getProjectAndMainFolderBySubFolder: async (projectId,mainFolderId,subFolderId) => {
      try {
          const response = await axios.get(`/api/projectFolder/getsubfolderdetails/${projectId}/${mainFolderId}/${subFolderId}`);
          if (response?.data?.success) {
            return response.data.data;
          }
      } catch (error) {
          throw new Error(
              error?.response?.data?.message || "Failed to fetch client projects."
          );
      }
  },
};

